import { api } from './configs/axiosConfig';

const endPoint = "/locations";

export const locationAPI = {
    getDeliveryLocations: async function () {
        const reponse = await api.request({
            url: `${endPoint}`,
            method: 'GET'
        });

        return reponse.data;
    }
}